// No scenario -> template field list lives here: the server copies a saved scenario's values itself
// (D21, D22), the client sends only which scenario (README.md, "Save and rename are two actions").

// Manage's Save as New Template edits its name in a draft row before anything is created (letter 99,
// 2.5); the draft rides the rename state under this id.
export const DRAFT_TEMPLATE_ID = '__new-template__'

// The selection a freshly opened pop-up starts with. Letter 99 (2.9): the top row starts checked only
// on "Start your analysis" (no scenario yet, S5.3); opened from Templates nothing is.
export function defaultCheckedIds(list, preselectFirst = false) {
  return new Set(preselectFirst && list[0] ? [list[0]._id] : [])
}

// Drops any selected id no longer present in nextList (Manage Templates' delete and reorder; fix
// round 23.09.2026). A selection pruning empties stays empty: Manage never preselects.
export function pruneCheckedIds(checkedIds, nextList) {
  const validIds = new Set(nextList.map((t) => t._id))
  return new Set([...checkedIds].filter((id) => validIds.has(id)))
}

export function countByType(templates, type) {
  return templates.filter((t) => t.template_type === type).length
}

// A template's own type is only relevant to the delete floor (S15 decision 6/9.3) via this count --
// never by comparing template_type strings elsewhere, the same "never key logic on name equality"
// lesson the legacy duplicate-tag bug (mr-6 spec S3.5, S10) is named after.
export function isDeletable(templates, template) {
  return countByType(templates, template.template_type) > 1
}

// Collision-safe and simple, per the task brief's own instruction not to port legacy's naming rule
// (mr-6 spec S3.5's unresolved "3,"/"(F)" defect). Case/whitespace-insensitive so "new template " and
// "New Template" collide -- a bare `includes` on the raw array would let both exist at once.
export function nextTemplateName(existingNames) {
  const base = 'New Template'
  const taken = new Set(existingNames.map((n) => n.trim().toLowerCase()))
  if (!taken.has(base.toLowerCase())) return base
  let n = 2
  while (taken.has(`${base} ${n}`.toLowerCase())) n++
  return `${base} ${n}`
}

// The server keeps at least one cash and one loan template per account and seeds a missing one on
// GET (decision D12); a list without both means that seed has not happened yet -- or the account is
// at the 50-template ceiling, where the seed is skipped and the type stays missing. Either way the
// cost is one GET per popup open, with no write from here.
export function missesStarterType(templates) {
  return countByType(templates, 'cash') === 0 || countByType(templates, 'loan') === 0
}
